import { KeyValueModel } from "model/api";
import { EnumTpCalculoModificador } from "model/enums/enum-tpcalculo-modificador";

export const TpCalculoModificadorMock: KeyValueModel[] = [
    new KeyValueModel(EnumTpCalculoModificador.Soma, "Soma dos Produtos"),
    new KeyValueModel(EnumTpCalculoModificador.Maior, "Valor do Maior"),
    new KeyValueModel(EnumTpCalculoModificador.Rateia, "Valor da Média"),
];
